
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { hashCode } from '@/util/string'

export default {
    props: {
        script: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            search: '',
            filteredVariables: [],
            editor: null,
            disabledSelect: false,
            showVariables: false,
            type: 'consultation-scripts',
            showPreview: false,
            clientId: null,
            isLoading: false,
            pageOptions: [],
            form: {
                subtype: null,
                title: null,
                html: '',
            }
        }
    },
    computed: {
        ...mapGetters(['surveyRoutes', 'survey', 'variablesOptions']),
        isPreviewDisabled () {
            return !this?.survey && !this.clientId
        },
    },
    watch: {
        async clientId () {
            if (this.clientId) {
                this.isLoading = true
                await this.$store.dispatch('getSurvey', { id: this.clientId })
                this.isLoading = false
            }
        },
        search () {
            if (this.search.length) {
                const pattern = new RegExp(this.search, 'i')
                this.filteredVariables = this.variablesOptions.filter(item => pattern.test(item.label))
            }
        }
    },
    async mounted () {
        this.updateForm()
        await this.getPageOptions()
        if (this?.survey?.id) {
            this.clientId = this.survey.id
        }
    },
    methods: {
        hashCode,
        async getPageOptions () {
            const { items } = await this.$try('getItems', { type: 'consultation-scripts' }, { spinner: false })
            const availableScripts = items.map(i => i.subtype)

            this.pageOptions = this.surveyRoutes
                .filter((route) => {
                    const rt = route.path.split('/').pop() || 'profile'
                    return !(availableScripts.includes(rt) && rt !== this.script?.subtype)
                })
                .map((surveyRoute) => {
                    return { text: surveyRoute.text, value: surveyRoute.path.split('/').pop() || 'profile' }
                })
        },
        updateForm () {
            if (this.script) {
                this.form = _.cloneDeep(this.script)
                this.disabledSelect = true
            }
        },
        validate () {
            return this.$validator.validate()
        },
        async save () {
            const valid = await this.validate()
            if (!valid) {
                return this.$store.$alert(this.$validator.errors.all().join('\n'))
            }

            Object.entries(this.form).forEach(([key, val]) => {
                if (['title', 'subtype'].includes(key)) return
                this[key] = this.$sanitizeScript(val)
            })

            const { error } = await this.$try(
                'setItem',
                `${this.type}-${this.form.subtype}`,
                this.form,
                { type: this.type, subtype: this.form.subtype },
            )
            if (error) {
                return this.$emit('error', error)
            }
            this.$emit('refresh')
            this.$emit('close')
        }
    }
}
